import { FC } from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';

export const AddPhotoIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="#9E9EA3" />
  </SvgIcon>
);
